export default {
    methods: {
        //改变请求的数目
        handleSizeChange(val) {
            this.page_size = val;
            this.getMyorder();
        },
        //查看详情的按钮事件
        handleDetail(row) {
            // console.log(row);
            this.order = row;
            this.dialogTableVisible = true;
            this.handelOrderOptions(row.id);
        },
        //查看订单的订单项目
        handelOrderOptions(id) {
            this.$post("purchased/shop_search", {
                token: this.$store.state.authority_management,
                order_id: id,
                offset: 0,
                length: 999
            }).then(res => {
                // console.log(res.data.result.data);
                this.ordersOption = res.data.result.data;
            });
        },
        //当前页改变所触发的事件
        handleCurrentChange(val) {
            this.currentPage = val;
            this.offset = (val - 1) * this.page_size;
            this.getMyorder();
        },
        //获取订单数据
        getMyorder: function() {
            //pay_type 1 支付宝 2微信
            //state 0 未付款 2已付款 5已失效
            this.$post("orders/shop_search", {
                token: this.$store.state.authority_management,
                offset: this.offset,
                length: this.page_size,
                pay_type: this.pay_type_value,
                state: this.order_type_value,
                user_name: this.nameSearch,
                code: this.orderNumSearch
            }).then(res => {
                // console.log(res.data);
                this.orders = res.data.result.data;
                this.total = res.data.result.total;
                return res.data.result.data;
            });
        },
        //确定搜索
        confirmSearch: function() {
            this.currentPage = 1
            this.$post("orders/shop_search", {
                token: this.$store.state.authority_management,
                offset: 0,
                length: this.page_size,
                pay_type: this.pay_type_value,
                state: this.order_type_value,
                user_name: this.nameSearch,
                code: this.orderNumSearch
            }).then(res => {
                // console.log(res.data);
                this.orders = res.data.result.data;
                this.total = res.data.result.total;
                return res.data.result.data;
            });
		},
		payType(value) {
			let payType = '';
			switch(value) {
				case 1:
					payType = '支付宝';
					break;
				case 2:
					payType = '微信';
					break;
				case 3:
					payType = '批量开课';
					break;
				case 4:
					payType = '银联';
					break;
				case 5:
					payType = '账号余额';
                    break;
                case 6:
                    payType = '郑州银行';
                    break;
			}
			return payType;
		}
    },
    created() {
        this.getMyorder();
    },
    data() {
        return {
            options: [
                {
                    value: "3",
                    label: "批量开课"
                },
                {
                    value: "5",
                    label: "账号余额"
                },
                {
                    value: "6",
                    label: "郑州银行"
                },
            ],
            order_options: [
                {
                    value: " ",
                    label: "全部订单"
                },
                {
                    value: "2",
                    label: "已支付订单"
                },
                {
                    value: "5",
                    label: "已失效订单"
                },
                {
                    value: "0",
                    label: "未支付订单"
                }
            ],
            //当前页面
            currentPage: 1,
            pay_type_value: "",
            order_type_value: "",
            orderNumSearch: "",
            nameSearch: "",
            dialogTableVisible: false,
            total: 0,
            page_size: 15,
            offset: 0,
            order: {},
            orders: [],
            ordersOption: []
        };
    }
};
